import dateFormat from 'dateformat';
import {
  GIFT_CARD_REDEEM_POINT_STATUS,
  GIFT_CARD_REDEEM_POINT_STATUS_TEXT,
} from '../../../enums/ProperksStatus';
import { Colors } from '../../../themes/colors';
import { formatNumber } from '../../../utils/NumberUtils';
import { challengeType, formatDateRange } from '../../mainComponents/ProPerks/utils';
import Level0 from '../../../images/properks_levels/level0.svg';
import Level1 from '../../../images/properks_levels/level1.svg';
import Level2 from '../../../images/properks_levels/level2.svg';
import Level3 from '../../../images/properks_levels/level3.svg';
import { states } from '../StatePicker';

const styles = {
  tableText: {
    fontWeight: '400',
    fontSize: '13px',
    fontFamily: 'Nunito',
    color: Colors.neutral_600,
    textAlign: 'center',
  },
};

const getColorStatus = (status) => {
  switch (status) {
    case GIFT_CARD_REDEEM_POINT_STATUS.SENT:
      return Colors.success_300;
    case GIFT_CARD_REDEEM_POINT_STATUS.PENDING:
      return Colors.warning_700;
    case GIFT_CARD_REDEEM_POINT_STATUS.FAILED:
      return Colors.error_500;

    default:
      return Colors.black;
  }
};

const formatAmount = (amount) =>
  `$${formatNumber(
    Math.abs(Number(String(amount).replace('$', '').replace(' Gift Card Redeemed', ''))),
  )}`;

export const properksRedemptionColumn = () => [
  {
    selector: (row) => row.createdAt,
    name: 'Date',
    format: (row) =>
      row.createdAt ? dateFormat(new Date(row.createdAt), 'mm/d/yyyy', { utc: true }) : '-',
    style: styles.tableText,
  },
  {
    selector: (row) => row.description,
    name: 'Gift Card Amount',
    format: (row) => (row.description ? formatAmount(row.description) : '-'),
    style: styles.tableText,
  },
  {
    selector: (row) => row.status,
    name: 'Status',
    cell: (row) => (
      <p style={{ ...styles.tableText, color: getColorStatus(row.status), fontWeight: '700' }}>
        {GIFT_CARD_REDEEM_POINT_STATUS_TEXT?.[row.status] ?? '-'}
      </p>
    ),
  },
];

export const properksProfessionalChallengeColumn = () => [
  {
    selector: (row) => row.name,
    name: 'Challenge Name',
    style: styles.tableText,
    format: (row) => row.name || '-',
    width: '200px',
  },
  {
    selector: (row) => row.type,
    name: 'Challenge',
    format: (row) =>
      row.type && row.completed_count
        ? `${formatNumber(row.completed_count)} ${challengeType?.[row.type] || row.type}`
        : '-',
    style: styles.tableText,
    width: '180px',
  },
  {
    selector: (row) => row.reward,
    name: 'Prize',
    format: (row) => (row.reward ? `${formatNumber(row.reward)} Points` : '-'),
    width: '110px',
  },
  {
    selector: (row) => row.date_start,
    name: 'Date Range',
    cell: (row) => (
      <div style={{ ...styles.tableText, display: 'flex', textAlign: 'left' }}>
        {(row.date_start && row.date_end ? `${formatDateRange(row)}` : '-')}
      </div>
    ),
    style: styles.tableText,
    width: '150px',
  },
  {
    selector: (row) => row.professions,
    name: 'Profession Type',
    style: styles.tableText,
    format: (row) => row?.professions?.join?.(', ') || '-',
    width: '150px',
  },
  {
    selector: (row) => row.levels,
    name: 'Level(s)',
    format: (row) => row?.levels?.map?.((item) => item) || '-',
    width: '160px',
    cell: (row) => (
      <div style={{ ...styles.tableText, display: 'flex' }}>
        {row.levels.map((item) => {
          switch (item) {
            case 0:
              return (
                <img src={Level0} alt="level0" style={{ ...styles.baseIconStyle, zIndex: 4 }} />
              );
            case 1:
              return (
                <img src={Level1} alt="level1" style={{ ...styles.baseIconStyle, zIndex: 3 }} />
              );
            case 2:
              return (
                <img src={Level2} alt="level2" style={{ ...styles.baseIconStyle, zIndex: 2 }} />
              );
            case 3:
              return (
                <img src={Level3} alt="level3" style={{ ...styles.baseIconStyle, zIndex: 1 }} />
              );

            default:
              return null;
          }
        })}
      </div>
    ),
  },
  {
    selector: (row) => row.states,
    name: 'State',
    style: styles.tableText,
    cell: (row) => (
      <div style={{ ...styles.tableText, display: 'flex', textAlign: 'left' }}>
        {row.states.length === states.length ? 'All' : row.states?.join?.(', ')}
      </div>
    ),
    width: '100px',
  },
  {
    selector: (row) => row.created_by,
    name: 'Admin',
    style: styles.tableText,
    format: (row) => row.created_by || '-',
    width: '200px',
  },
];